import { type PropsWithChildren, useMemo, useState } from "react";

import {
  type FocusedInput,
  maskedInputRegistryContext,
  type MaskedInputRegistryContextValue,
} from "src/workouts/exerciseAttributeInput.shared";

export function MaskedInputRegistryProvider(props: PropsWithChildren) {
  const [focusedInputs] = useState(() => {
    return new Map<string, FocusedInput>();
  });

  const value = useMemo<MaskedInputRegistryContextValue>(() => {
    return {
      blur: (id: string, element: HTMLInputElement) => {
        if (focusedInputs.get(id)?.element === element) {
          focusedInputs.delete(id);
        }
      },
      cleanup: (id: string) => {
        focusedInputs.delete(id);
      },
      focus: (id: string, element: HTMLInputElement, key: string) => {
        focusedInputs.set(id, {
          element,
          key,
        });
      },
      getKey: (id: string, value: string) => {
        return focusedInputs.get(id)?.key ?? value;
      },
    };
  }, [focusedInputs]);

  return (
    <maskedInputRegistryContext.Provider value={value}>
      {props.children}
    </maskedInputRegistryContext.Provider>
  );
}
